/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'azure_button': {
    width: 185,
    height: 40,
    viewBox: '0 0 185 40',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _fill="#F3F3F3" d="M0 0h185v40H0z"/><text font-family="AvenirNext-Medium, Avenir Next" font-size="14" font-weight="400" _fill="#2A2E37"><tspan x="58" y="24">Azure AD Sign In</tspan></text><path pid="1" _fill="#F3F3F3" d="M12 5h31v31H12z"/><path pid="2" _fill="#F35325" d="M13 6h14v14H13z"/><path pid="3" _fill="#81BC06" d="M28 6h14v14H28z"/><path pid="4" _fill="#05A6F0" d="M13 21h14v14H13z"/><path pid="5" _fill="#FFBA08" d="M28 21h14v14H28z"/></g>'
  }
})
